import React from "react";
import { FaChevronRight } from "react-icons/fa";
import { FaChevronLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { flowLabel } from "../../utils/creationFlow";
import "./ProgressBar.css";

const ProgressBar = ({ steps, currentStep }) => {
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart);
  const currentService = flowLabel(cart);

  return (
    <>
      <div className="progressbar-container">
        {/* Flèche Précédent */}
        <div className="previous-button mt-4" onClick={() => navigate(-1)}>
          <FaChevronLeft className="chevron-left" />
          <span>Précédent</span>
        </div>

        {/* Barre de progression */}
        <div className="d-flex justify-content-center align-items-center mt-4">
          {steps.map((step, index) => {
            // Détermine la classe de couleur de chaque étape
            let stepClass = "step";
            let chevronClass = "chevron";

            // Si c'est l'étape en cours, on la colore en bleu
            if (step === currentStep) {
              stepClass = "step current";
            }
            // Si c'est une étape validée (avant l'étape en cours), on la colore en vert
            else if (index < steps.indexOf(currentStep)) {
              stepClass = "step completed";
            }

            return (
              <React.Fragment key={index}>
                <div className={`step-container ${stepClass}`}>
                  <span>{step}</span>
                </div>

                {/* Affiche le chevron après chaque étape sauf la dernière */}
                {index < steps.length - 1 && (
                  <FaChevronRight className={chevronClass} />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
      {currentService && (
        <div className="flow-indicator-wrap">
          <p className="flow-indicator">
            <span className="flow-indicator-dot" aria-hidden="true" />
            {currentService}
          </p>
        </div>
      )}
    </>
  );
};

export default ProgressBar;
